import { drawerWidth } from '../../theme/componentStyles/Drawer.theme.styles'
import { styled } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'
import { Box } from '@mui/material'

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
})

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(7)} + 1px)`,
	},
})

const StyledDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}))

const CustomDrawer = ({ onMouseEnter, ...props }) => {
	return (
		<>
			<StyledDrawer {...props} onMouseEnter={onMouseEnter}>
				<Box>{props.children}</Box>
			</StyledDrawer>
		</>
	)
}

export default CustomDrawer
